import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconHomeCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M10.8303 1.80353C11.562 1.41616 12.438 1.41616 13.1697 1.80353L19.6697 5.24471C20.4881 5.67798 21 6.52815 21 7.45418V18.5C21 19.8807 19.8807 21 18.5 21H5.5C4.11929 21 3 19.8807 3 18.5V7.45418C3 6.52815 3.51187 5.67798 4.33028 5.24471L10.8303 1.80353ZM8.75 12C8.75 10.2051 10.2051 8.75 12 8.75C13.7949 8.75 15.25 10.2051 15.25 12C15.25 13.7949 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.7949 8.75 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeCircle;
